/* global gettext */

/**
 *
 * @todo stop using viewerUI for batch control.
 */
(function (sculpteo) {
  "use strict";

  var config = (sculpteo.MaterialConfiguration = {});

  config.defaultMaterialMap = {
    // 'casting_metal': 'casting_metal,bronze,raw,raw_metal',
  };

  /**
	 * We still need to use that file. It is easier to keep it and just replace the config.materialMap by window.materialOptionMap
	  window.materialOptionMap is fill it in design/print/index.html
	 */
  config.materialMap = window.materialOptionMap;
  config.materialBetaMap = window.materialOptionMapGroup;

  if (document.getElementById("MATERIAL_OPTIONS_TRANSLATIONS")) {
    config.materialTranslations = JSON.parse(
      document.getElementById("MATERIAL_OPTIONS_TRANSLATIONS").textContent
    );
  }

  config.materialTranslationsLong = {
    glossy: gettext("Glossy varnish"),
    matte: gettext("Matte varnish"),
  };

  config.materialDescriptions = {
    // Material famillies
    sls_plastic: gettext(
      "Selective Laser Sintering (SLS) is one of the most used 3D printing technologies.The object is fabricated by melting successive layers of powder together with a laser."
    ),
    polyjet_resin: gettext(
      "PolyJet 3D printers jet layers of curable liquid photopolymer onto a build tray. Each layer is cured by UV light immediately. This technology offers great detail, surface smoothness and precision."
    ),
    clip_resin: gettext(
      "CLIP (Continuous Liquid Interface Production) is a photochemical process that makes it possible to produce parts with excellent mechanical properties, resolution, and surface finish."
    ),
    laser_melting_metal: gettext(
      "Laser Melting is in an additive manufacturing method specially developed for 3D Printing metals and alloys. It uses a laser to melt successive layers of metal powder."
    ),
    casting_metal: gettext(
      "Produced through lost-wax casting of a 3D printed model. This process offers highly detailed models that are perfect for jewelry. It is not suitable for articulated designs however."
    ),
    hp_plastic: gettext(
      "Multi Jet Fusion is an additive manufacturing method invented and developed by the company Hewlett-Packard (HP). It creates parts additively thanks to a multi-agent printing process."
    ),
    sla_resin: gettext(
      "SLA technology can create 3d printed parts from a photopolymer resin. That liquid is then solidified by a laser layer by layer to create rigid and highly detailed prints that are comparable to injection molded plastics. The final product has a naturally smooth and mat surface."
    ),
    msla: gettext(
      "SLA technology can create 3d printed parts from a photopolymer resin. That liquid is then solidified by a laser layer by layer to create rigid and highly detailed prints that are comparable to injection molded plastics. The final product has a naturally smooth and mat surface."
    ),
    vacuum_casting: gettext(
      "Vacuum casting pours a liquid polyurethane resin into a silicone mould under vacuum, so that the resin fills every detail of the mould and traps no air. The mould is made from a 3D printed master model, and each mould casts a few dozen parts, which makes the process the fastest way to get a small series with the surface finish and the mechanical properties of an injection moulded part."
    ),
    metal_filament: gettext(
      "Metal-polymer composite ﬁlament is used to produce metal components in stainless steel type 316L using FFF (Fused Filament Fabrication) printer systems followed by an industry standard debinding and sintering process. 3D-printed parts acquire their final properties, for example in terms of hardness and strength, through this debinding and sintering process."
    ),

    // Materials
    // TODO get material translation from DB
    pa12_s: gettext(
      "PA12 S is a strong, lightweight nylon material prized for its smooth surface finish and excellent chemical resistance."
    ),
    pa_12_hp: gettext(
      "Our solid black plastic is a great material for prototyping and manufacturing parts. The multi-agent printing process invented by HP offers fine details and a smooth surface."
    ),
    nylon_pa12_100u: gettext(
      "Nylon PA12 is a great starter material. Strong, with a fairly good level of detail and slightly flexible, it comes in a wide range of finishes and colors. 100 to 120µm is the standard layer thickness."
    ),
    nylon_pa12_60u: gettext(
      "Nylon PA12 60µ is a strong material with good detail. Slightly flexible, it comes in different colors. The 60µm layer thickness offers the finest details and reduces staircase effects."
    ),
    pa11_sls: gettext(
      "Ultrasint® PA11 is a bio-derived powder material for advanced applications where toughness matters. It offers exceptionally high ductility and impact strength for any application requiring deformation and toughness, from automotive to medical."
    ),
    pa11_cf: gettext(
      "Ultrasint® PA11 black CF is a bio-derived powder material. Its well-balanced mechanical property profile, maintaining high ductility and impact performance at any time, makes it one of the strongest and most rigid materials in the industry."
    ),
    pa11_esd: gettext(
      "Ultrasint® PA11 ESD is a bio-derived powder material with electrostatic discharging properties for increased process safety in the electronic industry."
    ),
    tpu_sls: gettext(
      "The Selective Laser Sintering TPU (or SLS TPU) is a Thermoplastic Polyurethane material. If you are looking for a resistant, flexible, and rubbery material, this TPU is the perfect option."
    ),
    tpu_hp: gettext(
      "The Multijet Fusion TPU 01 (or MJF TPU) objects printed through Sculpteo are created from a fine Thermoplastic Polyurethane powder. This material offers durable, strong, and flexible parts."
    ),
    polypropylene_hp: gettext(
      "PP (Polypropylene) or HP 3D High Reusability PP is developed by BASF. This 3D printing material is an industrial-grade polypropylene. PP provides a high reusability ratio, producing functional parts batch after batch."
    ),
    nylon_pa12_grey: gettext(
      "Nylon PA12 (Grey) is a solid PA12 powder, ensuring resistance to discoloration. The material is both solid and flexible."
    ),
    pa11_hp: gettext(
      "Our PA11 is a bio-derived powder material for advanced applications where toughness matters. It offers exceptionally high ductility and impact strength for any application requiring deformation and toughness, from automotive to medical."
    ),
    vero_white: gettext(
      "VeroWhite is a rigid and glassy material with a smooth surface, perfect for high detailed visualization. Moving parts work quite well."
    ),
    vero_clear: gettext(
      "VeroClear is a translucent rigid material that offers exceptional surface detail, great dimensional stability and a smooth surface quality. It is an ideal material for clear parts."
    ),
    elastomeric_polyurethane: gettext(
      "Elastomeric Polyurethane is a general purpose stretchable material. It is the most flexible of all our CLIP materials. It can be used for connecting pieces like gaskets, washers and caps."
    ),
    rigid_polyurethane_70: gettext(
      "Rigid Polyurethane 70 is a tough, heat resistant material that is a perfect fit for the production of parts that require a high strength-to-weight ratio and moderate heat resistance."
    ),
    aluminium: gettext(
      "Aluminum has good mechanical properties. It is durable and lightweight, particularly effective in areas requiring a high strength/mass ratio and good thermal conductivity."
    ),
    stainless_steel: gettext(
      "316L Stainless Steel provides strong resistance against corrosion and is noted for its high ductility. It creates very strong parts that are ideal for mechanical objects."
    ),
    titanium: gettext(
      "Titanium (Grade 5, 6Al-4V) is very hard and highly resistant to oxidation and acids with an extremely high melting point. Lightweight, it has excellent mechanical characteristics."
    ),
    silver: gettext(
      "Our silver is composed of 92.5% sterling silver and 7.5% metal alloy. It is solid and relatively malleable making it perfect for jewelry creation."
    ),
    brass: gettext(
      "Our brass is composed of 82% copper and 18% zinc. It is perfect for jewellery and decorative creations."
    ),
    bronze: gettext(
      "Produced by the lost-wax casting of a 3D printed model. Not suitable for articulated designs. Highly detailed, perfect for jewelry."
    ),
    stainless_steel_420: gettext(
      "Our Steel / Bronze 420SS/BR is a great metal material for decorative objects and jewelry. The polishing finishes and the plating options give a professional looking aspect to the material for beautiful ornamental parts."
    ),
    prototyping_resin: gettext(
      "Prototyping Acrylate prints quickly has a good resolution and moderate strength for functional testing. It creates objects which are particularly smooth and precise. They are perfect for ornamental objects and proof-of-concept prototypes. They can also be used for more mechanical uses if the strain on the object is moderate."
    ),
    ultrafuse_316l: gettext(
      "Ultrafuse 316 L offers high temperature resistance and can handle complex shapes and is resistant to corrosion. This 3D printing metal has a wide range of uses from mechanical applications, tooling, mold creation and injection molding. The surface of the raw stainless steel is granular and slightly porous. The ultrafuse Stainless Steel 316 can be painted, welded, powder coated, drilled, tapped, machined."
    ),
    ultrafuse_17_4_ph: gettext(
      "Ultrafuse® 17-4PH is a stainless steel material for applications that require high hardness and mechanical strength."
    ),

    // Infill
    infill: gettext(
      "Reducing the infill will allow for weight reduction of your parts. Please keep in mind that any wall thinner than 2,4mm will be printed solid."
    ),

    // Finishes
    raw: gettext(
      "A raw finish means that the part is sandblasted but unpolished. The surface remains somewhat rough. This is the most affordable finish."
    ),
    polished: gettext(
      "Polished through mechanical polishing, the parts with this finish are smoother to touch. Layering effects can still be somewhat visible on rounded objects."
    ),
    dyed: gettext(
      "Dyeing tints the plastic deeply and reaches all surfaces of the part, including the most inaccessible recesses, resulting in a very uniform finish."
    ),
    dyed_polished: gettext(
      "Dyed Polished delivers parts that are both dyed to obtain color and polished to obtaina high quality surface finish. You benefit from a smoother surface on a colored part."
    ),
    matte_painted: gettext(
      "Matte Painted is a durable finish that retains the same shade without losing intensity. The colors are sprayed onto the material using a spray gun."
    ),
    glossy_painted: gettext(
      "Gloss paint provides a durable finish that retains the same shade without losing intensity. The colors are sprayed onto the material using a spray gun."
    ),
    myrtillage: gettext(
      "Smoothed through a physico-chemical process, the objects finished with our exclusive Smoothing Beautifier process have a glossy surface."
    ),
    chemical_smoothing: gettext(
      "Smoothed through a chemical process, the objects finished with our exclusive Chemical Smoothing process have a glossy surface."
    ),
    painted: gettext(
      "Painting provides a durable finish that retains the same shade without losing intensity. The colors are sprayed onto the material using a spray gun."
    ),
    painting: gettext(
      "Painting provides a durable finish that retains the same shade without losing intensity. The colors are sprayed onto the material using a spray gun."
    ),
    hand_polished: gettext(
      "Supports and support scars/bumps are manually removed."
    ),
    raw_resin_white: gettext(
      "Raw finish gives a part that is white and smooth."
    ),
    raw_resin_clear: gettext(
      "Raw offers a translucent part that is clear and ready to be used. The surface is smooth."
    ),
    dyed_resin: gettext(
      "Dyeing tints the plastic deeply and reaches all surfaces of the part, including the most inaccessible recesses, resulting in a very uniform finish."
    ),
    raw_clip: gettext(
      "Supports are removed from the model. Support scars/bumps will still be visible."
    ),
    raw_epd: gettext(
      "Supports are removed from the model. Support scars/bumps will still be visible."
    ),
    shot_peened: gettext(
      "Shot peening is a finishing technique that entails impacting a surface with round metallic particles. It is somewhat similar to sandblasting."
    ),
    rough: gettext(
      "The model goes through a quick sanding process. The remaining surface is rough but wearable as a ring or other item."
    ),
    mirror_polished: gettext(
      "The model is polished to a mirror shine in three steps through both a tribofinishing machine and hand polishing. Finer details may be less visible after the process."
    ),
    dyemansion_outdoor: gettext(
      "A dyeing finish with a matte look that resists friction and allows for a more consistent color between different production batches. A minimum order value is applied."
    ),
    dyemansion_lunettes: gettext(
      "A dyeing finishing with a satin look that withstands daily handling and resists to external conditions, scratching and rubbing. A minimum order value is applied."
    ),
  };

  config.materialThumbnails = {
    pa12_s: "black_plastic",
    pa_12_hp: "black_plastic",
    nylon_pa12_100u: "white_plastic",
    nylon_pa12_60u: "white_plastic",
    nylon_pa12_grey: "grey_plastic",
    pa_2210_fr: "white_plastic",
    pa12_grey_gf: "grey_plastic",
    food_grade_pa12_blue: "blue_plastic",
    pa11_cf: "pa11_cf",
    pa11_esd: "pa11_esd",
    pa11_sls: "white_resin", // same thumbnail as vero_white
    pa11_hp: "black_plastic", // same thumbnail as pa12_hp
    ultrafuse_17_4_ph: "ultrafuse_17_4_ph",
    tpu_sls: "tpu_sls",
    tpu_hp: "tpu_hp",
    polypropylene_hp: "polypropylene_hp",
    epd_1086: "prototyping_resin_black",
    rg_3280: "white_plastic", // same thumbnail as prototyping_resin
    st_45: "translucent_resin", // same thumbnail as vero_clear
    vero_white: "white_resin",
    vero_clear: "translucent_resin",
    elastomeric_polyurethane: "elastomeric_polyurethane",
    rigid_polyurethane_70: "rigid_polyurethane",
    aluminium: "metal_slm_aluminium_rough",
    stainless_steel: "metal_dmsl_stainless_steel_rough",
    titanium: "metal_dmsl_titanium_rough",
    silver: "mirror_polished_silver",
    brass: "raw_brass",
    bronze: "mirror_polished_brass",
    prototyping_resin: "white_plastic",
    transparent_resin: "translucent_resin",
    r_pet: "blue_plastic",
    petg_esd: "black_plastic",
    ultrafuse_316l: "metal_slm_aluminium_rough",
    stainless_steel_316l: "metal_dmsl_stainless_steel_rough",

    // 3Dprod materials. Every sprite is a placeholder borrowing an existing
    // tile, see sculpteo.materials.css, waiting for the 3Dprod photos
    sla_type_pa: "sla_type_pa",
    sla_type_pp: "sla_type_pp",
    sla_type_abs: "sla_type_abs",
    sla_type_pc: "sla_type_pc",
    msla_tough: "msla_tough",
    msla_high_temp: "msla_high_temp",
    msla_flex_80: "msla_flex_80",
    dlp_pro_black_10: "dlp_pro_black_10",
    dlp_rubber_65: "dlp_rubber_65",
    dlp_rigid_gray: "dlp_rigid_gray",
    mjf_pa12_gb: "mjf_pa12_gb",
    mjf_pa12_fr: "mjf_pa12_fr",
    fdm_pla: "fdm_pla",
    fdm_abs: "fdm_abs",
    fdm_tpu_95: "fdm_tpu_95",
    fdm_petg_v0: "fdm_petg_v0",
    fdm_tpu_esd_95: "fdm_tpu_esd_95",
  };

  // Warning : order is important as we're iteratin over this map and stop at the first match
  config.colorThumbnails = {
    "sls_plastic,nylon_pa12_100u,.*,white": "white_plastic",
    "sls_plastic,.*,dyed.*,blue": "blue_plastic",
    "sls_plastic,.*,dyed.*,yellow": "yellow_plastic",
    "sls_plastic,.*,dyed.*,red": "red_plastic",
    "sls_plastic,.*,dyed.*,green": "green_plastic",
    "sls_plastic,.*,dyed.*,orange": "orange_plastic",
    "sls_plastic,.*,dyed.*,black": "black_plastic",
    "sls_plastic,.*painted,white": "plastic_painted_white",
    "sls_plastic,.*painted,stone_gray": "plastic_painted_stonegrey",
    "sls_plastic,.*painted,gray": "plastic_painted_grey",
    "sls_plastic,.*painted,black": "plastic_painted_black",
    "sls_plastic,.*painted,gold": "plastic_painted_gold",
    "sls_plastic,.*painted,silver": "plastic_painted_silver",
    "sls_plastic,.*painted,blue": "plastic_painted_blue",
    "sls_plastic,.*painted,yellow": "plastic_painted_yellow",
    "sls_plastic,.*painted,red": "plastic_painted_red",
    "sls_plastic,.*painted,green": "plastic_painted_green",
    "sls_plastic,.*painted,violet": "plastic_painted_violet",
    "sls_plastic,.*painted,orange": "plastic_painted_orange",

    "sls_plastic,.*,dyemansion_outdoor,blue": "blue_plastic",
    "sls_plastic,.*,dyemansion_outdoor,yellow": "yellow_plastic",
    "sls_plastic,.*,dyemansion_outdoor,red": "red_plastic",
    "sls_plastic,.*,dyemansion_outdoor,green": "green_plastic",
    "sls_plastic,.*,dyemansion_outdoor,orange": "orange_plastic",
    "sls_plastic,.*,dyemansion_outdoor,black": "black_plastic",

    "sls_plastic,.*,dyemansion_lunettes,blue": "blue_plastic",
    "sls_plastic,.*,dyemansion_lunettes,yellow": "yellow_plastic",
    "sls_plastic,.*,dyemansion_lunettes,red": "red_plastic",
    "sls_plastic,.*,dyemansion_lunettes,green": "green_plastic",
    "sls_plastic,.*,dyemansion_lunettes,orange": "orange_plastic",
    "sls_plastic,.*,dyemansion_lunettes,grey": "grey_plastic",

    "sls_plastic,.*,black": "black_plastic",
    "sls_plastic,.*,white": "white_plastic",

    // Painting
    "hp_plastic,.*metallic_blue": "metallic_blue",
    "hp_plastic,.*metallic_silver": "metallic_silver",
    "hp_plastic,.*pure_white": "pure_white",
    "hp_plastic,.*jet_black": "jet_black",
    "hp_plastic,.*pure_red": "pure_red",
    "hp_plastic,.*grass_green": "grass_green",
    "hp_plastic,.*signal_orange": "signal_orange",
    "hp_plastic,.*light_blue": "light_blue",
    "hp_plastic,.*canola_yellow": "canola_yellow",
    "hp_plastic,.*transparent": "transparent",
    "hp_plastic,.*purple_violet": "purple_violet",
    "hp_plastic,.*skin_tone_a": "skin_tone_a",
    "hp_plastic,.*skin_tone_b": "skin_tone_b",
    "hp_plastic,.*skin_tone_c": "skin_tone_c",
    "hp_plastic,.*skin_tone_d": "skin_tone_d",
    "hp_plastic,.*custom_color": "custom_color",
    "hp_plastic,.*": "black_plastic",
    "sls_plastic,.*custom_color": "custom_color",

    "lcd_dlp,.*black": "prototyping_resin_black",
    "lcd_dlp,.*translucent": "translucent_resin",
    "lcd_dlp,.*custom_color": "custom_color",
    "lcd_dlp,.*gray": "gray_resin",
    "sla_resin,.*custom_color": "custom_color",
    "sla_resin,.*gray": "gray_resin",
    // MSLA is grouped under the sla_resin process (see gallery migration
    // 0392): its custom_color/gray already match the two rules above, only
    // amber (High Temp) needs a rule of its own.
    "sla_resin,.*amber": "light_yellow_resin",

    // The 3Dprod FDM colours. black and white already fall back to the
    // generic colours at the bottom of this map
    "fused_filament_fabrication,.*red": "red_plastic",
    "fused_filament_fabrication,.*orange": "orange_plastic",
    "fused_filament_fabrication,.*blue": "blue_plastic",
    "fused_filament_fabrication,.*yellow": "yellow_plastic",
    "fused_filament_fabrication,.*green": "green_plastic",
    "polyjet_resin,.*neon_yellow": "neon_yellow_resin",
    "polyjet_resin,.*neon_orange": "neon_orange_resin",
    "polyjet_resin,.*neon_pink": "neon_pink_resin",
    "polyjet_resin,.*intense_red": "intense_red_resin",
    "polyjet_resin,.*orange": "orange_resin",
    "polyjet_resin,.*marron_glace": "brown_resin",
    "polyjet_resin,.*pearl_gray": "gray_resin",
    "polyjet_resin,.*odyssey_blue": "blue_resin",
    "polyjet_resin,.*valley_green": "green_resin",
    "polyjet_resin,.*light_yellow": "light_yellow_resin",
    "polyjet_resin,.*translucent": "translucent_resin",
    // Maintenir black_resin avant white_resin pour matcher le slug polyjet_resin,vero_white,dyed_resin,black [WD-1373]
    "polyjet_resin,.*black": "black_resin",
    "polyjet_resin,.*white": "white_resin",

    "clip_resin,.*black": "prototyping_resin_black",

    // The vacuum casting resins. black and transparent already fall back to the
    // generic colours at the bottom of this map
    "vacuum_casting,.*beige": "beige_plastic",
    "vacuum_casting,.*off_white": "white_resin",
    "vacuum_casting,.*pale_yellow_translucent": "light_yellow_resin",
    "vacuum_casting,.*light_amber": "light_yellow_resin",

    white: "white_plastic",

    "casting_metal,.*silver": "mirror_polished_silver",
    "casting_metal,.*pink_gold_plated": "pink_gold",
    "casting_metal,.*gold_plated": "plated_gold_brass",
    "casting_metal,.*rhodium_black_plated": "black_rhodium",
    "casting_metal,.*rhodium_white_plated": "white_rhodium",
    "casting_metal,.*raw_metal": "raw_plastic",

    "metal_filament,.*raw_metal": "ultrafuse_17_4_ph",

    clear_blue: "blue_plastic",
    black: "black_plastic",
    translucent: "translucent_resin",
    transparent: "translucent_resin",

    // General purpose colors. Unprecise, but used in the material selector table
    "sls_plastic,.*white": "white_plastic",
    "sls_plastic,.*black": "black_plastic",
    "sls_plastic,.*gray": "grey_plastic",
    "sls_plastic,.*grey": "raw_plastic",
    "sls_plastic,.*blue": "blue_plastic",
    "sls_plastic,.*yellow": "yellow_plastic",
    "sls_plastic,.*red": "red_plastic",
    "sls_plastic,.*green": "green_plastic",
    "sls_plastic,.*orange": "orange_plastic",
    "sls_plastic,.*stone_gray": "plastic_painted_stonegrey",
    "sls_plastic,.*silver": "plastic_painted_silver",
    "sls_plastic,.*gold": "plastic_painted_gold",
    "sls_plastic,.*violet": "plastic_painted_violet",
  };

  config.finishThumbnails = {
    raw: "raw_plastic",
    raw_epd: "raw_plastic",
    raw_resin_white: "white_resin",
    raw_resin_clear: "translucent_resin",
    raw_clip: "elastomeric_polyurethane",
    polished: "polished_plastic",
    myrtillage: "myrtillage_plastic",
    chemical_smoothing: "myrtillage_plastic",
    dyed: "raw_plastic",
    dyed_polished: "raw_plastic",
    dyed_resin: "black_plastic",
    painted: "yellow_plastic",
    painting: "painting",
    matte_painted: "raw_plastic",
    glossy_painted: "raw_plastic",
    dyemansion_outdoor: "raw_plastic",
    dyemansion_lunettes: "raw_plastic",
    basic: "raw_plastic",
    basic_polished: "polished_plastic",
    rough: "metal_dmsl_titanium_rough",
    shot_peened: "metal_dmsl_stainless_steel_rough",
    mirror_polished: "mirror_polished_brass",
    hand_polished: "raw_plastic",
    dry: "raw_plastic",
    varnished: "translucent_resin",

    // Vernish
    none: "raw_plastic",
    matte: "raw_plastic",
    glossy: "raw_plastic",

    // Density
    infill_100: "infill-100",
    infill_80: "infill-80",
    infill_60: "infill-60",
    infill_50: "infill-50",
    infill_40: "infill-40",
    infill_20: "infill-20",
  };

  config.platedThickness = {
    casting_metal: {
      rhodium_white_plated: "1µm",
      rhodium_black_plated: "1µm",
      gold_plated: "3µm",
      pink_gold_plated: "3µm",
    },
  };
})((window.sculpteo = window.sculpteo || {}));
